import { Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubSink } from '../../../app/sub-sink';
import { FuseConfigService } from '@fuse/services/config.service';

@Component({
    selector   : 'fuse-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls  : ['./search-bar.component.scss']
})
export class FuseSearchBarComponent
{
    collapsed: boolean;
    toolbarColor: string;
    @Output() onInput: EventEmitter<any> = new EventEmitter();
    onConfigChanged: Subscription;
    private subs = new SubSink();
    constructor(
        private fuseConfig: FuseConfigService
    )
    {
        this.collapsed = true;
        this.subs.sink  = this.onConfigChanged =
            this.fuseConfig.onConfigChanged
                .subscribe(
                    (newSettings) => {
                        this.toolbarColor = newSettings.colorClasses.toolbar;
                    }
                );
    }

    collapse()
    {
        this.collapsed = true;
    }

    expand()
    {
        this.collapsed = false;
    }

    search(event)
    {
        const value = event.target.value;

        this.onInput.emit(value);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
        }

}
